import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  private resourcePath: string = 'help-spot';

  constructor(
    private httpClient: HttpClient) {
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || 'server Error');
  }

  public getHsDrivers(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath}/driver/all`)
      .pipe(catchError(this.errorHandler));
  }

  public getHsRequestDrivers(httpParams: HttpParams): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath}/request/driver/summary`, {
        params: httpParams
      })
      .pipe(catchError(this.errorHandler));
  }

  public getHsFiltersData(httpParams: HttpParams): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath}/request/filter`, {params: httpParams})
      .pipe(catchError(this.errorHandler));
  }
}
